import { render } from "./addpettycashin.vue?vue&type=template&id=148e2db2&scoped=true"
import script from "./addpettycashin.vue?vue&type=script&lang=js"
export * from "./addpettycashin.vue?vue&type=script&lang=js"

import "./addpettycashin.vue?vue&type=style&index=0&id=148e2db2&scoped=true&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148e2db2"]])

export default __exports__